export const homeObjOne = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Agriculture & Agribusiness',
  headline: 'Driving food security and job creation',
  description:
    'We invest in modern farming, agri-processing, and farmer empowerment to create sustainable employment and strengthen Ghana’s agricultural value chain.',
  buttonLabel: 'Learn More',
  imgStart: '',
  img: require('../../images/agriculture.jpg'),
  alt: 'Agriculture'
};

export const homeObjTwo = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Technology',
  headline: 'Innovative digital solutions for growth',
  description:
    'We build and support technology solutions that enhance productivity, enable automation, and empower businesses in a rapidly evolving digital world.',
  buttonLabel: 'Explore',
  imgStart: 'start',
  img: require('../../images/values.jpg'),
  alt: 'Technology'
};

export const homeObjThree = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Infrastructure',
  headline: 'Building the foundation for development',
  description:
    'From construction to logistics, we develop infrastructure that supports economic growth and improves livelihoods across communities.',
  buttonLabel: 'View Projects',
  imgStart: '',
  img: require('../../images/infrastructure1.jpeg'),
  alt: 'Infrastructure',
  link: '/infrastructure',   // 👈 add this
};

export const homeObjFour = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Our Impact',
  headline: 'Creating sustainable employment opportunities',
  description:
    'Our mission is to reduce unemployment by creating scalable opportunities across multiple sectors while promoting equity and sustainability.',
  buttonLabel: 'Get Involved',
  imgStart: 'start',
  img: require('../../images/mission.jpg'),
  alt: 'Impact'
};